// Live-revision adaptation of the admin settings routes.
//
// The overlay's `admin/admin-routes.tsx` was written against a newer provider revision where the app settings
// routes are declared in the app's own admin routes. The live revision declares them here
// (`appSettingsRoutes`) and resolves every page through `lazyAdminRoute`, which looks the component up in
// `@app/admin/routes/app-admin-routes.lazy`. The Solred panel is registered there.
import {RouteObject} from 'react-router';
import {lazyAdminRoute} from '@common/admin/routes/lazy-admin-route';

export const appSettingsRoutes: RouteObject[] = [
  {path: 'drive', lazy: () => lazyAdminRoute('DriveSettings')},
  {path: 'solred', lazy: () => lazyAdminRoute('SolredSettings')},
];
